export default __webpack_public_path__ + "static/media/bar.0cda9732.jpg";